import React from 'react'
import {
  Button,
  Box,
  Container,
  TextField,
  Typography,
  Grid,
} from '@material-ui/core'
import CTextField from 'src/components/CTextField'

interface SigninBrokerProps {
  signinUsername : string
  signinPasssword : string
  handleSigninData : (type:string,value:string) => void
  onSubmit : ()=>void
}

const SigninBrokerSection:React.FC<SigninBrokerProps> = ({
  signinUsername,
  signinPasssword,
  handleSigninData,
  onSubmit,
}) => {



  return (
  <Container maxWidth="xs">
    <Grid container direction="column" >
      <Typography variant="subtitle2" color="textSecondary">
        โปรดกรอกข้อมูล user ของ Broker ที่คุณเลือก
      </Typography>
      <Box mt={3}/>
      <TextField
        // className={classes.input}
        variant="filled"
        size="small"
        label="Username"
        value={signinUsername || ""}
        onChange={(e) => handleSigninData("username", e.target.value)}
      />
      <Box mt={3}/>
      <CTextField
        // className={classes.input}
        variant="filled"
        size="small"
        type="password"
        label="Password"
        value={signinPasssword || ""}
        onChange={(e) => handleSigninData("password", e.target.value)}
      />
      <Box mt={3}/>
      <Button variant="contained" color="primary" onClick={onSubmit}>
        ดำเนินการต่อ
      </Button>
    {/* <Box mb={1}/> */}
    </Grid>
  </Container>
  )
}

export default SigninBrokerSection